import { api, signalr } from '@/f1/service'
import agent from '../service'
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import _ from 'lodash';
import Language from './language'

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 15, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {}
})

export default {
  name: 'agentList',
  props: ['only_select', 'list_selected', 'agent_id', 'view_detail', 'server_agent'],
  watch: {
    list_selected() {
      let id_list = this.list_selected.map(r => r.id)
      this.agents = this.agents.map(r => {
        if (id_list.indexOf(r.id) > -1) {  r.check = true }
        else { r.check = false }
        return r
      })
      this.selected = id_list
      console.info("list_selected watch updated props data")
    },
    server_agent(){
      if(this.server_agent){
        this.multi_clear();
      }else{
        return
      }
    }
  },
  components: { DatePicker, Language },
  data: () => {
    return {
      selected : [],
      custom,
      download_link : "",
      copy_text : "copy",
      agents : [],
      show: true,
      so : default_opt(),
      exchange : "",
      // th : undefined, // timer handler
      all : {
        modal : false,
        confirm : false,
        type : '',
        text : ''
      }
    }
  },
  computed: {
    fields() { return _i18n_data.i18n_fields[this.i18n || 'EN']; },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    // extra function
    multi_click(record, index) {
      try{
        if(this.agent_id === undefined) {
          // 해당 값이 없으면 디테일로 변경
          return this.detail(record)
        }
        if(this.agent_id == record.id) { return this.$toastr.w(`${i18n_data._i18n_warning.agent_setting[this.i18n]}`) }
        this.multi_one(!record.check, { item: record }, false)
        console.debug("select", index)
      } catch (e) { this.$toastr.e(`${i18n_data._i18n_error.parser_failed[this.i18n]}`); console.error(e) }
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.check) { return 'table-success' }
    },
    multi_one(value, row) {
      try {
        if(this.agent_id == row.item.id) { return this.$toastr.w(`${i18n_data._i18n_warning.agent_setting[this.i18n]}`) }
        this.$parent.$emit("multi_one", { id: row.item.id, name: row.item.name, is_del: !value });
        if(!value) { this.selected = _.pull(this.selected, row.item.id) }
        else {
          this.selected.push(row.item.id)
        }
        this.selected = _.uniq(this.selected)
      } catch (e) { this.$toastr.e(`${i18n_data._i18n_error.parser_failed[this.i18n]}`); console.error(e) }
    },
    multi_all() {
      try {
        this.agents.forEach(r => {
          if(this.agent_id == r.id) { console.log("An agent from which to import settings"); return }
          else { r.check = true; this.selected.push(r.id) }
        })

        this.selected = _.uniq(this.selected)
        this.$parent.$emit("multi_all", _.uniq(this.agents.map(r => { if(this.agent_id != r.id) { return { name: r.name, id: r.id } } })))
      } catch (e) { this.$toastr.e(`${i18n_data._i18n_error.parser_failed[this.i18n]}`); console.error(e) }
    },
    multi_clear() {
      this.$parent.$emit("multi_clear", []); this.agents.forEach(r => r.check = false)
      this.$refs._list.clearSelected()
      this.selected = []
    },
    // extra function end
    copyText() {
      var copyText = document.getElementById("myText");
      copyText.select();
      document.execCommand("copy");
      alert("Copid : " + copyText.value);
      this.copy_text = "copied";
    },
    hideModal() { this.$refs['modal-download'].hide() },
    all_cmd() {
      console.log(this.all.type)
      if (_.indexOf(['start', 'stop', 'upgrade'], this.all.type) > -1) {
        this.all_cmd_group(this.all.type)
        this.all.modal = false
        this.all.confirm = false
      } else { this.$toastr.w(`${_i18n_data._i18n_warning.all_cmd[this.i18n]}`) }
    },
    // upgrade_all() { this.all("update"); }, start_all() { this.all("start"); }, stop_all(){ this.all("stop"); },
    all_cmd_group(cmd){
      try {
        if(this.agents == null || this.agents.length < 1) { return this.$toastr.e(`${_i18n_data._i18n_error.agent_check[this.i18n]}`)}
        this.agents.forEach(async r => {
          // if(cmd == 'update') {
          //   agent.ws.Cmd(cmd, r.id)
          //   return
          // }

          // Todo : cmd 에 따라 쓰이는 api 가 달라서 해당 구분을 해줘야함.
          // 밑에 쓰인 api 는 
          // if(cmd == 'start'){
          //   let rs = wf.agent.start({ id : r.id });
          //   if(rs.error) { return this.$toastr.e("start failed") }
          //   return
          // }
          // else if(cmd == 'stop'){
          //   let rs = wf.agent.stop({ id : r.id });
          //   if(rs.error) { return this.$toastr.e("stop failed") }
          //   return
          // }
          // else if(cmd == 'upgrade'){
          //   let rs = wf.agent.upgrade({ id : r.id });
          //   if(rs.error) { return this.$toastr.e("upgrade failed") }
          //   return
          // }

          let rs = await api.wsfinder.WSFinder_Call('agent', cmd, { id : r.id });
          if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.start_failed[this.i18n]}`) }
          return

          // agent.ws.Cmd(cmd, r.id)
        });
        this.$toastr.i(cmd, `${_i18n_data._i18n_info.done[this.i18n]}`)
      } catch (e) { console.info(e); this.$toastr.e(e) }
    },
    download_info(){ this.$refs.warring.show(); this.$refs.modalRef.show(); },
    reset() { this.so = default_opt(); this.$refs._list.refresh();},
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'agent', cmd : 'list'
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, target : so.target, cmd : so.cmd, body: { and: [{name : 'is_del', value:false, op: '='}], or: [], sort: [{name : 'id', op : 'desc'}] } }
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        if(!value) { continue }
        switch(key) {
          case 'backup_mode' : search.body.and.push({name: 'setting', value : `%backup_mode":${value}%`, op : 'like'}); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: `%${value}%`, op: 'like' }); break;
        }
      }
      try {
        let rs = await api.wsfinder.WSFinder(search);
        // let rs = await wf.agent.list(search);
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }
        this.so.totalRows = rs.total;
        this.$parent.$emit('count', this.so.totalRows)
        _.forEach(rs.body, r => { r.ms = 0, r.alive = false, r.check = this.selected.indexOf(r.id) > -1 });
        this.agents = rs.body || [];
        setTimeout(() => this.ping_status(), 300);
        return this.agents;
      } catch(e) { console.log(e); this.$toastr.w(`${_i18n_data._i18n_error.load_failed[this.i18n]}`); }
    },
    detail(item) {
      if(this.view_detail){
        this.multi_click(item)
      }else{
        this.$router.push(`agent/${item.id}`);
      }
    },
    async ping_status() {
      console.log('window[th]', window['th'])
      if(window['th']) { clearTimeout(window['th']); }
      if(this.agents &&  this.agents.length) {
        this.agents.forEach(r => {
          try {
            agent.ws.Cmd("ping", `${r.id}`).then(x => this.response_handler(x))
            agent.ws.Cmd("status", `${r.id}`).then(x => this.response_handler(x))
          } catch(e) { console.log(e) }
        })
        window['th'] = setTimeout(this.ping_status, 3000);
      }
    },
    response_handler(m)
    {
      let index = _.findIndex(this.agents, { id : m.agent_id })
      switch(m.cmd) {
        case 'pong':
          // 다시 짜야 함
          if(this.agents) {
            // console.log(this.agents[index])
            this.agents[index] = Object.assign(this.agents[index], { ms : Math.abs(new Date().getTime() - Number(m.body)), alive : true });
          }
          break;
        case 'status':
          m.body = typeof m.body == typeof '' ? JSON.parse(m.body) : m.body
          _.filter(this.agents, { id : m.agent_id }).forEach(a => {
            let update = { progress : ((m.body.scan_count/(m.body.scan_count_left+m.body.scan_folder_left)) * 100), scanning : m.body.running, is_real_time : m.body.is_real_time }
            if (m.body.running === false && this.agents[_.findIndex(this.agents, { id : m.agent_id })].scanning === true) {
              this.$toastr.i(`${i18n_data._i18n_info.response_handler[this.i18n]}`, this.agents[_.findIndex(this.agents, { id : m.agent_id })].name)
            }
            this.agents[_.findIndex(this.agents, { id : m.agent_id })] = _.assign(a, update);
          });
          break;
        case 'resource':
          this.$toastr.w(m.body, this.agents[_.findIndex(this.agents, { id : m.agent_id })].name)
          break;
        default: break;
      }
    },
  },
  created() {
    if(window['th']) { clearTimeout(window['th']); window['th'] = undefined; }
    console.log('agent.list.vue', 'created');
  },
  destroyed() {
    console.log('agent.list.vue', 'destroyed');
    if(window['th']) { clearTimeout(window['th']); window['th'] = undefined; }
  },
  mounted() {
    console.log('agent.list.vue', 'mounted');
    signalr.subscribe('wsfinder_response', this.response_handler)
    if(window['th']) { clearTimeout(window['th']); window['th'] = undefined; }
  },
}
